import React from "react";
import ResponsiveTable from "Components/responsiveTable/ResponsiveTable";
import { useHistory, useLocation, Link } from "react-router-dom";
import t from "Utils/translation";
import WarningBanner from "Components/warningBanner/WarningBanner";
import StatusBadge from "Components/statusBadge/StatusBadge";
import s from "../../delivery.scss";

const DeliveryDomainUsers = function ({ accounts }) {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className={s.dashboardContainer}>
      <div className={s.dashboardContent}>
        <div className={s.dashboardItem1}>
          <div className="settingTitle">{t("delivery.domains.accounts.connectedAccounts.title")}</div>
          <div className="sectionDesc">{t("delivery.domains.accounts.connectedAccounts.desc")}</div>
        </div>
        <div className={s.dashboardItem2}>
          <ResponsiveTable
            history={history}
            location={location}
            headers={[
              { name: t("table.header.status"), size: "1rem" },
              {
                name: t("table.header.delivery.account.name"),
                key: "username",
                size: "10rem",
              },
              { name: t("table.header.delivery.description"), size: "12rem" },
            ]}
            rows={accounts.map((accountData) => (
              <tr key={accountData.id}>
                <td>
                  <div className="expand flexCenter">
                    <StatusBadge data={accountData} type="delivery-account" />
                  </div>
                </td>
                <td>{accountData.username}</td>
                <td>{accountData.description}</td>
              </tr>
            ))}
            showAddIcon={false}
            showAddMsg={false}
            addDesc={t("delivery.domains.accounts.noAssociatedAccounts.desc")}
          />
          <Link to="/delivery/accounts">
            <div className="mt-8">
              <WarningBanner title="" info color="blue" msg={t("delivery.domains.accounts.warningMessage")} />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DeliveryDomainUsers;
